<template>
    <div v-wechat-title="title" class="device-binding">
        <el-row class="align-left padding20">
            <el-col :span="4">
                <el-scrollbar :style="{ height: this.screenHeight + 'px' }">
                    <div v-for="g in unBindingDevice" :key="g.value">
                        <h1>
                            {{ g.label }}<span class="fg-info">({{ (g.devices && g.devices.length) || 0 }})</span>
                        </h1>
                        <draggable class="padding-left10" tag="div" v-model="g.devices" v-bind="deviceDragOption" v-if="g.devices && g.devices.length > 0">
                            <!-- <transition-group type="transition" :name="'flip-list'"> -->
                            <div v-for="d in g.devices" :key="d.id" :class="{ 'device-item': true, undraggable: d.undraggable }">{{ d.name }}&nbsp;{{ d.device_no && `(${d.device_no})` }}</div>
                            <!-- </transition-group> -->
                        </draggable>
                        <span class="fg-info" v-else>暂无设备</span>
                    </div>
                </el-scrollbar>
            </el-col>
            <el-col :span="20" class="padding20">
                <el-scrollbar :style="{ height: this.screenHeight + 'px' }">
                    <el-row>
                        <el-col :md="12" :lg="6" :xl="6" v-for="rb in room_bed" :key="rb.parent_name + rb.id" class="bed-card">
                            <el-card>
                                <div slot="header" class="header line-height20 ellipsis">
                                    <font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon>
                                    <span>{{ `${rb.parent_name}-${rb.name}` }}</span>
                                </div>
                                <el-scrollbar class="content">
                                    <draggable
                                        class="list-group"
                                        tag="div"
                                        v-model="rb.devices"
                                        v-bind="dragOptions"
                                        @change="change($event, { locationType: rb.ward, locationId: rb.id, locationName: rb.name })"
                                    >
                                        <!-- <transition-group type="transition" tag="div" :name="'flip-list'"> -->
                                        <div class="list-group-item" v-for="d in rb.devices" :key="d.id">
                                            {{ d.name }}&nbsp;{{ d.device_no && `(${d.device_no})` }}
                                            <span class="el-icon-close" @click.prevent.stop="unbinding(rb, d)" />
                                        </div>
                                        <!-- </transition-group> -->
                                    </draggable>
                                </el-scrollbar>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-scrollbar>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
export default {
    name: `DeviceBinding`,
    components: { draggable },
    props: {},
    data() {
        return {
            title: `基础数据-设备绑定`,
            allDevice: [],
            unBindingDevice: [],
            room_bed: [],
            allDeviceId: []
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        ...mapGetters([`sys_enums`, `active_ward`, `screenHeight`]),
        deviceDragOption() {
            return {
                animation: 0,
                group: { name: `device`, put: false, pull: `clone` },
                disabled: false,
                ghostClass: `ghost`,
                sort: false,
                filter: `.undraggable`
            }
        },
        dragOptions() {
            return {
                animation: 0,
                group: `device`,
                disabled: false,
                ghostClass: `ghost`,
                sort: false
            }
        }
    },
    methods: {
        init() {
            if (this.active_ward) {
                let that = this
                let unBindingDeviceInfo = []
                let roomBedInfo = []
                let req1 = that.myaxios.get(`/api/AcisSystem/Device/GetDeviceLocation`) // 获取待绑定 的手术间或苏醒床位
                let req2 = that.myaxios.get(`/api/AcisSystem/Device/Get`) // 获取所有设备
                that.myaxios.all(req1, req2).then(([resp1, resp2]) => {
                    that.allDevice = _.filter(resp2, d => {
                        return !d.is_deleted && (`ow_${d.dic_operating_ward_id}` == this.active_ward.value || `rw_${d.dic_recovery_ward_id}` == this.active_ward.value)
                    })
                    that.allDeviceId = _.map(that.allDevice, d => {
                        return d.id
                    })
                    let g = _.groupBy(that.allDevice, `type_no`)
                    unBindingDeviceInfo = _.map(that.sys_enums.Enum_PhysioParamCategory, d => {
                        d.devices = g[d.value]
                        return d
                    })
                    roomBedInfo = _.filter(resp1, d => {
                        return `ow_${d.dic_operating_ward_id}` == this.active_ward.value || `rw_${d.dic_recovery_ward_id}` == this.active_ward.value
                    }).map(d => {
                        d.devices = []
                        return d
                    }) // _.orderBy(,['parent_name','ward','name'])

                    let req = that.myaxios.post(`/api/AcisSystem/Device/GetLocationDeviceAll`, roomBedInfo)
                    req.then(data => {
                        data = _.filter(data, d => {
                            return that.allDeviceId.indexOf(d.value) !== -1
                        })
                        roomBedInfo.forEach(rb => {
                            rb.devices = data
                                .filter(t => parseInt(t.group) == rb.id)
                                .map(d => {
                                    let r = _.find(that.allDevice, { id: d.value })
                                    let g = _.find(unBindingDeviceInfo, { value: r && r.type_no })
                                    g.devices = _.filter(g.devices, d => {
                                        return d.id != r.id
                                    })
                                    return r
                                })
                        })

                        that.unBindingDevice = unBindingDeviceInfo
                        that.room_bed = roomBedInfo
                    })
                })
            }
        },
        change({ added }, { locationType, locationId, locationName }) {
            if (!added) return
            let { element } = added
            let that = this
            let device = _.find(that.allDevice, { id: element.id })
            that.$set(device, `undraggable`, true) // 禁止当前设备拖拽
            // 后台保存数据
            that.myaxios
                .put(`/api/AcisSystem/Device/Put`, {
                    id: device.id,
                    name: device.name,
                    dic_operating_room_id: locationType == `手术间` ? locationId : 0,
                    dic_recovery_bed_id: locationType == `复苏床` ? locationId : 0
                })
                .then(data => {
                    // 绑定成功，移除待绑定列表
                    let g = _.find(that.unBindingDevice, { value: element.type_no })
                    g.devices = _.filter(g.devices, d => {
                        return d.id != element.id
                    })
                    that.init()
                })
                .catch(e => {
                    that.init()
                    that.$set(device, `undraggable`, false) // 允许当前设备拖拽
                })
        },
        unbinding(rb, d) {
            // 后台保存数据
            let that = this
            that.myaxios
                .put(`/api/AcisSystem/Device/Put`, {
                    id: d.id,
                    name: d.name,
                    dic_operating_room_id: 0,
                    dic_recovery_bed_id: 0
                })
                .then(data => {
                    // 绑定成功，移除待绑定列表
                    rb.devices = _.filter(rb.devices, dv => {
                        return dv.id != d.id
                    })
                    let g = _.find(that.unBindingDevice, { value: d.type_no })
                    that.$set(d, `undraggable`, false) // 允许当前设备拖拽
                    g.devices.push(d)
                })
                .catch(e => {
                    console.log(`解除绑定失败：`, e.data && e.data.detail)
                })
        }
    },
    watch: {
        active_ward: function() {
            this.init()
        }
    }
}
</script>
<style scoped>
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.flip-list-move {
    transition: transform 0.5s;
    display: block;
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Device/DeviceBinding.vue